export default __webpack_public_path__ + "static/media/self-motivation.47018b6c.webp";